import { render, staticRenderFns } from "./pronominaladverb.vue?vue&type=template&id=b090a6e4&scoped=true"
import script from "./pronominaladverb.vue?vue&type=script&lang=js"
export * from "./pronominaladverb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b090a6e4",
  null
  
)

export default component.exports